import React from "react";

const Bottom = () => {
  return <img src={require("../BurgerAssets/bottom.svg")} alt="" />;
};

export default Bottom;
